var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"fab":"","small":""},on:{"click":function($event){return _vm.toggleBuildings()}}},on),[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("home")])],1)]}}])},[_c('span',[_vm._v("3D Bygninger")])])
}
var staticRenderFns = []

export { render, staticRenderFns }